import React, { Component } from "react";
import { getUserInfo, setUserInfo, changeAccountSettings } from "../../services/api";
import Auth from "../../services/auth";

class MobileEdit extends Component {
  constructor(props) {
    super(props);

    const userInfo = getUserInfo() || {};
    const metadata = userInfo.user_metadata || {};
    const prevName =
      metadata.customFirstname ||
      userInfo.username ||
      userInfo.given_name ||
      userInfo.nickname ||
      "";
    const prevEmail = metadata.customEmail || userInfo.email || "";

    this.state = {
      username: prevName,
      email: prevEmail,
      prevName,
      prevEmail,
      updating: false,
      resultMessage: null,
    };

    this.updateAccount = this.updateAccount.bind(this);
  }

  updateAccount() {
    const { username, email, prevName, prevEmail } = this.state;
    const nameChanged = username !== prevName;
    const emailChanged = email !== prevEmail;
    if (!nameChanged && !emailChanged) return;

    this.setState({ updating: true });

    const type = nameChanged && emailChanged
      ? "username_change email_change"
      : nameChanged
      ? "username_change"
      : "email_change";

    changeAccountSettings({
      type,
      values: { username, email },
    })
      .then(() => {
        const userInfo = getUserInfo();
        if (userInfo) {
          setUserInfo(
            Object.assign(userInfo, {
              user_metadata: {
                customFirstname: username,
                customEmail: email,
              },
            })
          );
        }
        this.setState({
          updating: false,
          resultMessage: "Success. Logging out in 3 secs...",
        });
        setTimeout(() => Auth.logout("/login"), 3000);
      })
      .catch(() => {
        this.setState({ updating: false, resultMessage: "Something went wrong." });
      });
  }

  render() {
    const { username, email, prevName, prevEmail, updating, resultMessage } = this.state;
    const { history } = this.props;
    const noChange = username === prevName && email === prevEmail;
    const isEmpty = !username || !email;

    return (
      <div id="account-menu-container">
        {!resultMessage && (
          <div className="one column row links overview">
            <div className="left aligned column overview">
              <span className="header-title">First Name</span>
              <input
                value={username}
                onChange={(e) => this.setState({ username: e.target.value })}
                disabled={updating}
              />
            </div>
            <div className="left aligned column overview">
              <span className="header-title">Email</span>
              <input
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                disabled={updating}
              />
            </div>
          </div>
        )}
        {updating && (
          <div className="one column row links overview-btn">
            <div className="center aligned column">Updating...</div>
          </div>
        )}
        {resultMessage && (
          <div className="one column row links overview-btn">
            <div className="center aligned column">{resultMessage}</div>
          </div>
        )}
        {!updating && !resultMessage && (
          <div className="one column row links overview-btn">
            <div className="center aligned column">
              <button
                className="ui fluid primary button overview"
                onClick={this.updateAccount}
                disabled={noChange || isEmpty}
              >
                UPDATE
              </button>
            </div>
          </div>
        )}
        {resultMessage && (
          <div className="one column row links overview-btn">
            <div className="center aligned column">
              <button
                className="ui fluid primary button overview"
                onClick={() => history.push("/account?screen=overview")}
              >
                BACK
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MobileEdit;
